<script lang="ts">import ToggleAlternative4 from "../icons/toggle-alternative4.svelte";
import Toggle from "../icons/toggle.svelte";
import { stateUi } from "@infinitro/config";
import { sidebarCollapsed } from "@infinitro/global";
const handleToggleSidebar = () => {
	sidebarCollapsed.update((value) => !value);
};
$: useAlternative = $stateUi.header.headerStyle === "alternative";
$: useAlternative2 = $stateUi.header.headerStyle === "alternative2";
$: useAlternative4 = $stateUi.header.headerStyle === "alternative4";
</script>

<button
	class:toggle-button-alternative={useAlternative || useAlternative4}
	class:toggle-button-alternative-2={useAlternative2}
	class:toggle-button-alternative-4={useAlternative4}
	class="toggle-button {$sidebarCollapsed && 'toggle-active'} "
	on:click={handleToggleSidebar}
>
	{#if useAlternative4}
		<ToggleAlternative4 bind:active={$sidebarCollapsed} />
	{:else}
		<Toggle bind:active={$sidebarCollapsed} />
	{/if}
</button>

<style>
	.toggle-button {
		display: none;
		height: 40px;
		width: 40px;
		min-width: 40px;
		align-items: center;
		justify-content: center;
		border-width: 1px;
		border-color: var(--color-neutral-900);
		background-color: var(--color-background-900);
}
@media (min-width: 1024px) {
		.toggle-button {
				display: flex;
		}
}
	.toggle-button {
		border-radius: var(--border-radius-header-toggle);
	}

	.toggle-button-alternative {
		border-color: var(--color-accent-700);
		background-color: var(--color-tertiary-500);
		background-image: unset;
}

	.toggle-button-alternative-4 {
		border-width: 0px;
		background-color: var(--color-background-700);
		color: var(--color-text-100);
}

	.toggle-button-alternative-2 {
		border-style: none;
		background-color: transparent;
		background-image: unset;
}
</style>
